import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class CompanyService {
  //  isEskyAdmin:boolean;
  headerOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  apiUrlCompanies = 'api/agents/callcentercompanies';

  constructor(private http: HttpClient) { }
  all() {

    return this.http.get('api/company/all').pipe(map((res: Response) => res));;
  }
  allByCompany(company) {

    return this.http.get('api/company/allbycompany?originCompany=' + company );
    }

  getUsersByCompanyIds(companyIds: number[]): Observable<any[]> {

    return this.http.post<any[]>('api/company/getUsersByCompanyIds', companyIds);

    }

    updatePartnerLevels(users: any[]): Observable<void> {
      return this.http.post<void>(`api/company/updatePartnerLevels`, users);
    }

  addCompany(data) {
    return this.http.post(
      'api/company/new',
      JSON.stringify(data),
      this.headerOptions
    )
  }
  addCustomerAdminPrestashop(data) {
    return this.http.post(
      'api/company/addadminprestashop',
      JSON.stringify(data),
      this.headerOptions
    )
  }
  addCustomerAdmin(data) {
    return this.http.post(
      'api/company/addadmin',
      JSON.stringify(data),
      this.headerOptions
    )
  }
  addEcwidCustomerAdmin(data) {
    return this.http.post(
      'api/company/addEcwidadmin',
      JSON.stringify(data),
      this.headerOptions
    ).pipe(map((res: Response) => res));
  }
  addCustomer(data) {
    return this.http.post(
      'api/company/addCustomer',
      JSON.stringify(data),
      this.headerOptions
    )
  }

  deleteCompany(idcompany: number) {
    return this.http.post(
      'api/company/deleteCompany?companyId=' + idcompany,
      this.headerOptions
    );
  }
  setPlan(idcompany: number, idplan: number) {
    return this.http.get('api/company/setplan?idPlan=' + idplan.toString() + '&idCompany=' + idcompany.toString());
  }

  upload(fileToUpload: any, idcompany: number) {
    let input = new FormData();
    input.append("file", fileToUpload);
    input.append("idcompany", idcompany.toString());
    return this.http
      .post("api/company/uploadlogo", input);
  }
  //get balance of the company of the connected user
  getBalance() {
    return this.http.get('api/company/getbalance')
  }
  updateBalance(newbalance) {
    return this.http.post('api/company/updatebalance?newbalance=' + newbalance, this.headerOptions);
  }
  createAccount(data) {
    return this.http.post(
      'api/company/createaccount',
      JSON.stringify(data),
      this.headerOptions
    )
  }

  updateCompany(company) {
    return this.http.post(
      'api/company/updateCompany',
      JSON.stringify(company),
      this.headerOptions
    )
  }

  getImgFile(filename) {
    return this.http.get('api/company/getCompanyLogo?filename=' + filename);
  }
  confirmRegistration(token) {
    return this.http.get('api/company/confirmRegistration?token=' + token, {
      reportProgress: true,
      responseType: 'text'
    });
  }
  updateLimit(companyid, newLimit) {
    return this.http.post('api/company/updateCompanyLimit?companyid=' + companyid + '&newLimit=' + newLimit, this.headerOptions);
  }
  topupCompanyAccount(companyid, amount, subCategory, internalComment, publicComment) {
    return this.http.post('api/company/topupCompanyAccount?companyid=' + companyid + '&amount=' + amount + '&subCategory=' + subCategory + '&internalComment=' + internalComment + '&publicComment=' + publicComment, this.headerOptions)
  }
  configureCompanyClientStatus(companydto, clientStatus) {
    return this.http.post('api/company//status/configure?clientStatus=' + clientStatus, JSON.stringify(companydto), this.headerOptions)
  }
  getCompanyLimit() {
    return this.http.get('api/company/getCompanyLimit');
  }
  //check if company exist
  checkCompanyExist(companyName) {
    return this.http.get('api/company/check?companyName=' + companyName);
  }
  //get nbr and cost of a company sent orders by country
  getSentOrdersByCountry() {
    return this.http.get('api/orders/getSentOrdersByCountry');
  }
  getNbrSentOrdersByCompany() {
    return this.http.get('api/orders/getNbrSentOrdersByCompany');
  }
  getSentOrdersByWarehouse() {
    return this.http.get('api/orders/getSentOrdersByWarehouse');
  }
  getSentOrdersByCountryAndPeriod(fromDate, toDate) {
    return this.http.get('api/orders/getSentOrdersByCountryAndPeriod?fromDate=' + fromDate.toString() + '&toDate=', toDate.toString());
  }
  getNbrSentOrdersByCompanyAndPeriod(fromDate, toDate) {
    return this.http.get('api/orders/getNbrSentOrdersByCompanyAndPeriod?fromDate=' + fromDate.toString() + '&toDate=', toDate.toString());
  }
  getSentOrdersByWarehouseAndPeriod(fromDate, toDate) {
    return this.http.get('api/orders/getSentOrdersByWarehouseAndPeriod?fromDate=' + fromDate.toString() + '&toDate=', toDate.toString());
  }
  //total shipping Cost of the connected company
  getSentOrdersShippingCostByCompany() {
    return this.http.get('api/orders/getTotalShippingCostByCompany');
  }
  getSentOrdersShippingCostByCompanyAndPeriod(fromDate, toDate) {
    return this.http.get('api/orders/getTotalShippingCostByCompanyAndPeriod?fromDate=' + fromDate.toString() + '&toDate=', toDate.toString());
  }

  getSentOrdersByShippingMethodAndPeriod(fromDate, toDate) {
    return this.http.get('api/orders/getSentOrdersByShippingMethodAndPeriod?fromDate=' + fromDate.toString() + '&toDate=', toDate.toString());
  }

  getAllWebmasters(): Observable<string[]> { // Change the return type to string[]
    return this.http.get<string[]>('api/Order/allwebmasters');
  }
  
  // Updated method to fetch companies for Tunisia
  fetchCompaniesForTunisia(): Observable<any> {
    const params = new HttpParams().set('countries', 'Tunisia');
    return this.http.get(this.apiUrlCompanies, { params });
  }

}
